<template>
  <el-form
    label-width="180px"
    :inline="true"
    ref="formRef"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="用户" required>
      <el-input v-model="form.sfz_name" disabled clearable />
    </el-form-item>
    <el-form-item label="可用金额" required>
      <el-input v-model="form.money" disabled clearable />
    </el-form-item>
    <el-form-item label="冻结金额" required>
      <el-input v-model="form.frozen_money" disabled clearable />
    </el-form-item>
    <el-form-item label="类型" required>
      <el-select
        @change="changeType"
        v-model="form.type"
        placeholder=""
        clearable
      >
        <el-option label="减少" value="1,3,4" />
        <el-option label="增加" value="0,2" />
      </el-select>
    </el-form-item>
    <el-form-item
      label="账变类型"
      prop="class_id"
      :rules="[
        {
          required: true,
          message: '请选择账变类型',
          trigger: ['change'],
        },
      ]"
    >
      <el-select v-model="form.class_id" placeholder="账变类型" clearable filterable>
        <el-option
          v-for="item in typesEnum"
          :label="item.title"
          :key="item.title"
          :value="item.id"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      label="金额"
      prop="money3"
      :rules="[
        {
          required: true,
          message: '请输入金额',
          trigger: ['blur'],
        },
      ]"
    >
      <el-input v-model="form.money3" clearable />
    </el-form-item>
    <el-form-item
      label="描述"
      prop="desc"
      :rules="[
        {
          required: true,
          message: '请输入描述',
          trigger: ['blur'],
        },
      ]"
    >
      <el-input v-model="form.desc" clearable />
    </el-form-item>
  </el-form>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, nextTick } from "vue";

const form = ref({
  sfz_name: "",
  username: "",
  money3: "",
  type: "",
  desc: "",
  class_id: "",
});
const formRef = ref(null);

const props = defineProps(["item"]);

onMounted(() => {
  nextTick(() => {
    form.value = Object.assign(form, props.item);
  });
  getTYpesEnum();
});

const { proxy } = getCurrentInstance();
const typesEnum = ref([]);

const changeType = () => {
  getTYpesEnum();
};

const getTYpesEnum = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/MoneyLog/classes?type=" + (form.value.type || ""),
  });
  if (res.code == 0) {
    typesEnum.value = res.data.sort((a, b) => {
      if (a.id === 56) return -1;
      if (b.id === 56) return 1;
      if (a.id === 43) return -1;
      if (b.id === 43) return 1;
      if (a.id === 55) return -1;
      if (b.id === 55) return 1;
      if (a.id === 54) return -1;
      if (b.id === 54) return 1;
      if (a.id === 46) return -1;
      if (b.id === 46) return 1;
      if (a.id === 37) return -1;
      if (b.id === 37) return 1;
      return 0;
    });
  }
};

defineExpose({ form, formRef });
</script>

<style lang="less" scoped>
.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}
/deep/ .el-radio-group {
  width: 220px;
}
.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}
.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
}
</style>
